const PROXY_PATH = '/roomeet-quiz-api-proxy';
const PDF_STREAM_PHP = '/pdf-stream.php';

function getQuizApiOrigin() {
    const raw = (process.env.REACT_APP_API_URL || '').trim();
    if (!raw) return 'https://quiz-api.roomeet.ir';
    try {
        const href = raw.startsWith('http') ? raw : `https://${raw.replace(/^\/\//, '')}`;
        return new URL(href).origin;
    } catch {
        return 'https://quiz-api.roomeet.ir';
    }
}

/**
 * آدرس عمومی PDF برای gview — بدون پروکسی dev و با origin واقعی API.
 */
export function resolvePublicPdfUrlForGview(url) {
    if (!url || typeof url !== 'string') return '';

    let resolved = String(url).trim();

    if (typeof window !== 'undefined' && window.location?.origin) {
        const proxyPrefix = `${window.location.origin}${PROXY_PATH}`;
        if (resolved.startsWith(proxyPrefix)) {
            resolved = `${getQuizApiOrigin()}${resolved.slice(proxyPrefix.length)}`;
        }
    }

    if (!/^https?:\/\//i.test(resolved)) {
        if (resolved.startsWith('//')) {
            resolved = `https:${resolved}`;
        } else if (resolved.startsWith('/')) {
            resolved = `${getQuizApiOrigin()}${resolved}`;
        }
    }

    return resolved;
}

/**
 * آدرس stream با پشتیبانی Range — برای Safari/Firefox مناسب‌تر از لینک مستقیم FTP است.
 */
export function buildPdfStreamUrl(url) {
    const publicUrl = resolvePublicPdfUrlForGview(url);
    if (!publicUrl) return url || '';

    const pathMatch = publicUrl.match(/upload\/files\/.+/i);
    if (!pathMatch) return publicUrl;

    return `${getQuizApiOrigin()}/api/v1/media/stream?path=${encodeURIComponent(pathMatch[0])}`;
}

/** آدرس PDF برای نمایشگر native موبایل (استریم + fit افقی) */
export function buildMobileNativePdfSrc(url) {
    const stream = buildPdfStreamUrl(url);
    if (!stream) return '';
    return `${stream}#view=FitH`;
}

/**
 * استریم PDF از همان origin سایت آزمون (فقط اندروید) — از pdf-stream.php روی هاست.
 */
export function buildSameOriginPdfStreamUrl(url) {
    const publicUrl = resolvePublicPdfUrlForGview(url);
    const pathMatch = publicUrl.match(/upload\/files\/.+/i);
    if (!pathMatch) return buildMobileNativePdfSrc(url);

    const query = `path=${encodeURIComponent(pathMatch[0])}`;
    const publicBase = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

    if (typeof window !== 'undefined' && window.location?.origin) {
        return `${window.location.origin}${publicBase}${PDF_STREAM_PHP}?${query}#view=FitH`;
    }

    return buildMobileNativePdfSrc(url);
}

/**
 * آدرس embed نمایشگر گوگل (gview). فقط برای باز کردن در تب جدید — در iframe کار نمی‌کند
 * (گوگل X-Frame-Options: SAMEORIGIN دارد و «refused to connect» می‌دهد).
 */
export function buildGoogleGviewEmbedUrl(absolutePdfUrl) {
    const publicUrl = resolvePublicPdfUrlForGview(absolutePdfUrl);
    if (!publicUrl) return '';
    return `https://docs.google.com/gview?embedded=1&url=${encodeURIComponent(publicUrl)}`;
}

/**
 * در development، آدرس فایل روی همان origin سرو می‌شود تا pdf.js با fetch دچار CORS نشود
 * (پروکسی در `src/setupProxy.js`). با `REACT_APP_SKIP_PDF_DEV_PROXY=true` در `.env` غیرفعالش کنید.
 * در production همان URL برگردانده می‌شود.
 */
export function normalizePdfUrlForViewer(url) {
    if (!url || typeof url !== 'string') return url;
    if (process.env.REACT_APP_SKIP_PDF_DEV_PROXY === 'true') {
        return url;
    }
    if (process.env.NODE_ENV !== 'development' || typeof window === 'undefined' || !window.location?.origin) {
        return url;
    }

    const apiOrigin = getQuizApiOrigin();
    let resolved = String(url).trim();
    if (!/^https?:\/\//i.test(resolved)) {
        if (resolved.startsWith('//')) {
            resolved = `https:${resolved}`;
        } else if (resolved.startsWith('/')) {
            resolved = `${apiOrigin}${resolved}`;
        }
    }

    if (!resolved.startsWith(`${apiOrigin}/`)) {
        return url;
    }

    // بقیهٔ URL را همان‌طور که در رشتهٔ اصلی encode شده نگه می‌داریم؛
    // new URL().pathname گاهی decode می‌کند و مسیر اشتباه → 404/500 روی پروکسی.
    const tail = resolved.slice(apiOrigin.length);
    if (!tail.startsWith('/')) {
        return url;
    }

    return `${window.location.origin}${PROXY_PATH}${tail}`;
}
